module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGklEQVR4Ae3BAQEAAACCoP6vdkjAAAAAgHsBECAAAbGjFMwAAAAASUVORK5CYII="